import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { Modal } from "../../../app/components";
import { useStudyPlan } from "../../../app/contexts/study.context";
import Typography from "@material-ui/core/Typography";
import { useNavigate, useParams } from "react-router-dom";
import PrimaryButton from "../../../app/components/buttons/primary";
import OutlinedButton from "../../../app/components/buttons/outlined";

const UnsavedChangesModal = ({ open = false, onToggle, to, isDisabled = false }) => {
  const {
    savePlan,
    clearChangeLog,
    fetchStudyPlan,
    fetchCohortStudyPlan,
    isSequential,
    studyPlan,
  } = useStudyPlan();
  const navigate = useNavigate();
  const { id, planId } = useParams();
  
  const originalStepRef = useRef(null);
  
  useEffect(() => {
    if (open && !originalStepRef.current) {
      const currentPath = window.location.pathname;
      let correctStep;
      
      if (currentPath.includes("review")) {
        correctStep = 3;
      } else if (currentPath.includes("countries-and-site-groups")) {
        correctStep = 2;
      } else {
        correctStep = 1; // Overall Parameters
      }
      
      originalStepRef.current = correctStep;
    }

    if (!open) {
      originalStepRef.current = null;
    }
  }, [open]);

  const handleSaveAndExit = async () => {
    const saved = await handleSave();
    if (saved) {
      to ? redirect() : handleBackToList();
    }
  };

const handleExitWithoutSaving = async () => {
  console.log("[UnsavedChangesModal] Exit without saving. to:", to);
  clearChangeLog();
  if (to) {
    await fetchStudyPlan(planId);
    if (isSequential) {
      await fetchCohortStudyPlan(planId);
    }
    redirect();
  } else {
    handleBackToList();
  }
};
  const handleBackToList = () => navigate(`/ctpo/study-plans/${id}`);

  const handleSave = async () => {
    const isNew = planId.includes("new-plan_") ? true : false;
    const correctActualStep = originalStepRef.current || 1;

    // Restore the source step before saving — the stepper mutates ActualStep to the
    // destination step before opening this modal, which causes savePlan to take the
    // wrong branch (step 2 logic instead of step 1 logic).
    studyPlan.ActualStep = correctActualStep;

    const result = await savePlan({ isNew });
    return result;
  };

  const redirect = () =>
    to ? navigate(to) : navigate(`/ctpo/study-plans/${id}`);

  return (
    <Modal
      open={open}
      onClose={onToggle}
      aria-labelledby="clone study plan"
      aria-describedby="clone a study plan"
      title="You Have Unsaved Changes"
    >
      <Typography>
        Are you sure you want to exit without saving your changes first? Select
        an action below to continue.
      </Typography>
      <Container>
        <OutlinedButton onClick={handleExitWithoutSaving}>
          Exit Without Saving
        </OutlinedButton>
        <PrimaryButton
          onClick={handleSaveAndExit}
          disabled={isDisabled}
        >
          Save & Exit
        </PrimaryButton>
      </Container>
    </Modal>
  );
};

export default UnsavedChangesModal;

const Container = styled.div`
  margin-top: 2em;
  display: flex;
  justify-content: space-between;
  gap: 1em;
`;
